// extracted by mini-css-extract-plugin
module.exports = {"container":"page-module--container--1M1L4","imageContainer":"page-module--image-container--2SDvA"};